module.exports = __webpack_public_path__ + "img/grid-3230205_1920.02e09c48.jpg";